exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searching .v-card__title{font-size:15px}.source-logo{float:right;width:22px;height:22px;opacity:.8;margin-right:0;margin-top:8px}.profile-pic{border-radius:50%;width:30px;height:30px;float:left}.v-data-table-header,.v-data-table__mobile-row__header{display:none}header .v-toolbar__content{width:auto}", ""]);

// exports
